"use client";

import type { ChoghadiyaResponse } from "@/lib/api/panchang";

interface ChoghadiyaSummaryProps {
  result: ChoghadiyaResponse;
}

export function ChoghadiyaSummary({ result }: ChoghadiyaSummaryProps) {
  return (
    <div className="card-sacred p-6 sm:p-8">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
        <div>
          <span className="block text-[11px] font-semibold uppercase tracking-wider mb-1 text-ish-text-faint">
            Sunrise
          </span>
          <span className="text-[16px] font-bold tabular-nums text-ish-dark">{result.sunrise}</span>
        </div>
        <div>
          <span className="block text-[11px] font-semibold uppercase tracking-wider mb-1 text-ish-text-faint">
            Sunset
          </span>
          <span className="text-[16px] font-bold tabular-nums text-ish-dark">{result.sunset}</span>
        </div>
        <div>
          <span className="block text-[11px] font-semibold uppercase tracking-wider mb-1 text-ish-text-faint">
            Day
          </span>
          <span className="text-[16px] font-bold text-ish-dark">{result.vara.name}</span>
        </div>
        <div>
          <span className="block text-[11px] font-semibold uppercase tracking-wider mb-1 text-ish-text-faint">
            Vaar
          </span>
          <span className="text-[16px] font-bold text-ish-dark">{result.vara.name_hi}</span>
        </div>
      </div>
    </div>
  );
}
